import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Manifesto from "@/components/Manifesto";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

function Landing() {
  return (
    <div className="page grain" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <HowItWorks />
        <Manifesto />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  return (
    <>
      <SmoothScroll>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </SmoothScroll>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#222",
            color: "#FDFBF7",
            border: "1px solid rgba(255,255,255,0.08)",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </>
  );
}

export default App;
